export const AmplitudePageViews = {
  Home: 'view home screen',
  Trademark: 'view trademark screen',
  SelfServeOrco: 'view ssorco',
  Drawer: 'view drawer screen',
  Tax: 'view tax screen',
  PastTax: 'view past tax screen',
  Legal: 'view legal screen',
  LegalCheckout: 'view legal checkout screen',
  PastLegal: 'view past legal screen',
  RegisteredAgent: 'view inbox screen',
  Documents: 'view documents screen',
  Orders: 'view orders screen',
  Compliance: 'view compliance screen',
  ComplianceCheckout: 'view compliance checkout screen',
  BusinessToolkit: 'view business toolkit screen',
  BusinessToolkitNext: 'view business toolkit next screen',
  GoogleWorkspace: 'view google workspace screen',
  AssetsManager: 'view eSignature screen',
  BillingESign: 'view eSignature billing screen',
  DocumentEditor: 'view document editor screen',
  ESignature: 'view eSignature screen',
  AssetViewer: 'view eSignature screen',
  Login: 'view login screen',
  LoginSuccess: 'view login success screen',
  ChangePassword: 'view change password',
  Mfa: 'view mfa screen',
  AccountDetails: 'view account details screen',
  AuthorizedContacts: 'view authorized contacts screen',
  PaymentHistory: 'view payment history screen',
  Subscriptions: 'view subscriptions screen',
  VirtualMailPlanSelection: 'view virtual mail plan selection screen',
  VirtualMailAddressSelection: 'view virtual mail address selection screen',
  VirtualMailCheckout: 'view virtual mail checkout screen',
  VirtualMailOrderComplete: 'view virtual mail order complete page screen',
  VirtualMailWelcomePage: 'view virtual mail welcome screen',
  VirtualMailRecipient: 'view virtual mail view recipient screen',
  VirtualMailApplicant: 'view virtual mail view applicant screen',
  VirtualMailNotarize: 'view virtual mail view notarize screen',
  VirtualMailDashboard: 'view virtual mail view dashboard screen',
  ViewPage: 'view page',
  ViewUpcomingConsultations: 'view upcoming consultations',
  WorkspaceSelector: 'view workspace selector',
  DocumentCenter: 'view document center',
  VirtualMailAccountReactivation:
    'view virtual mail account reactivation screen',
  OnboardingBusinessLocation: 'view onboarding business location',
  OnboardingBusinessName: 'view onboarding business name',
  OnboardingEntityType: 'view onboarding entity type',
  OnboardingFormationDate: 'view onboarding formation date',
  OnboardingRegistrationStage: 'view onboarding registration stage',
  OnboardingWorkspaceSelection: 'view onboarding workspace selection',
  OnboardingLoading: 'view onboarding loading',
  DocumentSummarizerHome: 'view document summarizer home screen',
  DocumentSummary: 'view document summary screen',
  DocumentUploadNew: 'view document new upload screen',
  DocumentSharedSummary: 'view shared document summary screen',
  Cart: 'view universal checkout cart screen',
  Checkout: 'view universal checkout checkout screen',
  Confirmation: 'view universal checkout confirmation screen',
  Workspaces: ' view workspaces screen',
  OrderHistory: 'view order history screen',
  ScheduleConsultation: 'view consultation screen',
  FormsBuilder: 'view forms builder screen',
  ComplianceHealthScan: 'view compliance health scan report screen',
  SignatureCapture: 'view signature capture screen',
  AiContract: 'view ai contract screen',
};

export type AmplitudePageViews =
  (typeof AmplitudePageViews)[keyof typeof AmplitudePageViews];
